<template>
    <div class="ns-today-time-sheet">
        <!-- <div class="float-right my-3">
            <el-input v-model="search_emp_by_id_name" clearable class="mx-5" placeholder="Search by employee name and id"
                style="width: 350px"></el-input> 

            <el-button size="medium" icon="el-icon-download" class="action-btn" @click="exportCSV()">Export CSV</el-button>
        </div> -->

        <div v-loading="is_time_sheet_loading" class="ns-table-section">
            <table class="ns-table">
                <thead class="ns-sticky-header">
                    <tr>
                        <th style="width: 70px;"><el-checkbox v-model="select_all" @change="selectAllOpt"></el-checkbox></th>
                        <th style="width: 150px;">Shift Date</th>
                        <th style="width: 190px;">Employee
                            <el-popover placement="bottom" trigger="click">
                                <div>
                                    <el-checkbox-group v-model="selected_department_list">
                                        <el-checkbox
                                            v-for="(dept, dept_index) in employeeDepartments"
                                            :key="dept_index"
                                            class="mb-2 checkbox-lable"
                                            :label="dept"
                                            style="display: block"
                                        ></el-checkbox>
                                    </el-checkbox-group>
                                </div> 
                                <span slot="reference">
                                    <img 
                                    src="../../../assets/images/filterBlack.png"
                                    width="9"
                                    alt=""
                                    class="ml-1 cursor-pointer"
                                    />
                                </span>
                            </el-popover>
                        </th>
                        <th style="width: 160px;">Location Name</th>
                        <th class="ns-tito-cu-width">TIME IN-TIME OUT
                            <el-popover placement="bottom" trigger="click">
                                <div>
                                    <el-checkbox-group v-model="selected_availability">
                                        <el-checkbox
                                            v-for="(dept, dept_index) in availabilityOpt"
                                            :key="dept_index"
                                            class="mb-2 checkbox-lable"
                                            :label="dept"
                                            style="display: block"
                                        ></el-checkbox>
                                    </el-checkbox-group>
                                </div> 
                                <span slot="reference">
                                    <img 
                                    src="../../../assets/images/filterBlack.png"
                                    width="9"
                                    alt=""
                                    class="ml-1 cursor-pointer"
                                    />
                                </span>
                            </el-popover>
                        </th>
                        <th style="width: 100px;">Duration</th>
                        <th style="width: 195px;"> Location </th>
                        <th style="width: 250px;">COST <span style="font-size: 0.6rem;">(INR)</span></th>
                        <th style="width: 150px;">STATUS
                            <el-popover placement="bottom" trigger="click">
                                <div>
                                    <el-checkbox-group v-model="selected_status_list">
                                        <el-checkbox
                                            v-for="(status, status_index) in statusOptList"
                                            :key="status_index"
                                            class="mb-2 checkbox-lable"
                                            :label="status"
                                            style="display: block"
                                        ></el-checkbox>
                                    </el-checkbox-group>
                                </div> 
                                <span slot="reference">
                                    <img 
                                    src="../../../assets/images/filterBlack.png"
                                    width="9"
                                    alt=""
                                    class="ml-1 cursor-pointer"
                                    />
                                </span>
                            </el-popover>
                        </th>
                        <!-- <th>&nbsp;</th> -->
                    </tr>
                </thead>
                <tbody v-if="computedTimeSheetData.length">
                    <tr v-for="(time_sheet, time_index) in computedTimeSheetData" :key="time_index"
                        class=" ns-time-sheet-tr">
                        <td>
                            <el-checkbox v-model="time_sheet.is_select" :disabled="time_sheet.is_approved" @change="selectOpt"></el-checkbox>
                        </td>
                        <td> {{ time_sheet.shift_date | formatDate }} </td>
                        <td>
                            <div class="title ellipsis ns-ts-emp-col">
                                {{ time_sheet.employee_full_name }}
                            </div>
                            <p class="ns-sub-title ns-gray mt-1">{{ time_sheet.employee_department }}</p>
                            <p class="ns-sub-title ns-gray mt-1 font-normal">{{ time_sheet.employee_code }}</p>
                        </td>
                        <td> {{ getStoreName(time_sheet.store) }} </td>
                        <td>
                            <div class="mb-3">
                                <span style="margin-right: 6px;" class="text-amplitude">Regularized:</span>
                                <span class="mr-2 text-amplitude"> {{ time_sheet.regularized_in ?
                                    formatTime(time_sheet.regularized_in) :
                                    '00:00' }} </span>
                                <span class="mx-2 text-amplitude"> - </span>
                                <span class="ml-2 text-amplitude"> {{ time_sheet.regularized_out ?
                                    formatTime(time_sheet.regularized_out) :
                                    '00:00' }} </span>
                                <!-- <span class="ml-2">  ( {{ time_sheet.regularized_out ? getDuration(time_sheet.regularized_in,
                                                                    time_sheet.regularized_out) : '0 Hrs' }}) </span> -->

                                <span class="mx-2">
                                    <el-popover v-model="time_sheet.is_editable_popover" placement="right" width="400"
                                        trigger="manual">
                                        <div v-if="time_sheet.is_editable_popover" v-loading="popover_loading"
                                            class="ns-ts-action">
                                            <p class="text-sm font-semibold mt-1">Update Timesheet</p>

                                            <el-select v-model="time_sheet.action_type" style="width:100%" class="mt-2"
                                                placeholder="Select" @change="timeSheetChanged(time_sheet.uId)">
                                                <el-option v-for="item in statusOpt" :key="item.value" :label="item.label"
                                                    :value="item.value">
                                                </el-option>
                                            </el-select>

                                            <!-- Edit action -->
                                            <template v-if="time_sheet.action_type === 'shift'">
                                                <p class="text-sm font-normal mt-4">Shift</p>
                                                <div class="flex items-center mt-1">
                                                    <DateTimePicker v-model="time_sheet.regularized_in"
                                                        v-validate="emp_shift_edit_dialog ? 'required' : ''"
                                                        :displayed-value="time_sheet.regularized_in" name="In time"
                                                        :shift-time-slots="generateTimeSlots(1, time_sheet.shift_date)"
                                                        label="In time" class="mr-3"
                                                        @change="updatedInTime(time_sheet.regularized_in)" />
                                                    <DateTimePicker v-model="time_sheet.regularized_out"
                                                        v-validate="emp_shift_edit_dialog ? 'required' : ''"
                                                        :displayed-value="time_sheet.regularized_out" name="Out time"
                                                        :shift-time-slots="shift_end_time_slot"
                                                        :disabled-condition="time_sheet.regularized_in" label="Out time"
                                                        @change="generateTimeSlotsForDateTimePickerByFunc(time_sheet.regularized_in, time_sheet.regularized_out, 1, 'break_start_time_slot')" />
                                                </div>
                                                <p class="text-sm font-normal mt-1">Break</p>
                                                <div class="flex items-center mt-1">
                                                    <DateTimePicker v-model="time_sheet.regularized_break_in"
                                                        v-validate="emp_shift_edit_dialog ? 'required' : ''"
                                                        :displayed-value="time_sheet.regularized_break_in" name="In time"
                                                        :shift-time-slots="break_start_time_slot" label="In time"
                                                        class="mr-3"
                                                        @change="generateTimeSlotsForDateTimePickerByFunc(time_sheet.regularized_break_in, time_sheet.regularized_out, 1, 'break_end_time_slot')" />
                                                    <DateTimePicker v-model="time_sheet.regularized_break_out"
                                                        v-validate="emp_shift_edit_dialog ? 'required' : ''"
                                                        :displayed-value="time_sheet.regularized_break_out" name="Out time"
                                                        :shift-time-slots="break_end_time_slot" label="Out time" />
                                                </div>
                                            </template>
                                            <div class="flex item-center mt-3" style="justify-content: flex-end">
                                                <el-button class="ns-cancel-btn mini-btn" size="mini"
                                                    @click="closeTimeSheetEdit(time_sheet)">Cancel</el-button>
                                                <el-button size="mini" class="ns-approve-btn mini-btn"
                                                    @click="saveData(time_sheet)">Save & Approve</el-button>
                                                <!-- <el-button v-else-if="!time_sheet.is_approved" size="mini"
                                                    class="ns-approve-btn mini-btn"
                                                    @click="approveData(time_sheet.timesheet_id)">Approve</el-button> -->
                                            </div>
                                            <!-- Edit action -->
                                        </div>
                                        <i slot="reference"
                                            class="el-icon-edit-outline cursor-pointer mr-2 default-icon text-amplitude text-lg"
                                            @click="editTimeSheetPopover(time_sheet, time_index)"></i>
                                    </el-popover>
                                </span>

                            </div>
                            <div class="mb-3">
                                <span style="margin-right: 19px;" class="font-normal">
                                    Actual:
                                    <el-popover placement="top-start" width="510" trigger="hover">
                                        <div class="ns-table-popover">
                                            <table>
                                                <thead>
                                                    <tr>
                                                        <td>&nbsp;</td>
                                                        <td class="font-bold">In Time - Out Time</td>
                                                        <td class="font-bold">Duration</td>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr>
                                                        <td class="font-bold">Regularized</td>
                                                        <td>
                                                            <template>
                                                                {{ time_sheet.regularized_in ? formatTime(time_sheet.regularized_in) : '00:00'
                                                                }} -
                                                                {{ time_sheet.regularized_out ? formatTime(time_sheet.regularized_out) :
                                                                    '00:00' }}
                                                            </template>
                                                           
                                                        </td>
                                                        <td>{{ time_sheet.regularized_in ? getDuration(time_sheet.regularized_in,
                                                            time_sheet.regularized_out) : '0 Hrs' }}</td>
                                                    </tr>
                                                    <tr>
                                                        <td>Break 1</td>
                                                        <td>
                                                            {{ time_sheet.regularized_break_in ?
                                                                formatTime(time_sheet.regularized_break_in) : '00:00' }} -
                                                            {{ time_sheet.regularized_break_out?
                                                                formatTime(time_sheet.regularized_break_out) : '00:00' }}
                                                        </td>
                                                        <td>{{ time_sheet.regularized_out ?
                                                            getDuration(time_sheet.regularized_break_in,
                                                                time_sheet.regularized_break_out) : '0 Hrs' }}</td>
                                                    </tr>
                                                    <tr>&nbsp;</tr>
                                                    <tr>
                                                        <td class="font-bold">Actual</td>
                                                        <td>
                                                            <template v-if="time_sheet.is_absent">
                                                                <span class="mr-2"> Absent </span>
                                                            </template>
                                                            <template v-else>
                                                                {{ time_sheet.actual_in ? formatTimeUTC(time_sheet.actual_in) : '00:00'
                                                                }} -
                                                                {{ time_sheet.actual_out ? formatTimeUTC(time_sheet.actual_out) :
                                                                    '00:00' }}
                                                            </template>
                                                           
                                                        </td>
                                                        <td>{{ time_sheet.actual_in ? getDuration(time_sheet.actual_in,
                                                            time_sheet.actual_out) : '0 Hrs' }}</td>
                                                    </tr>
                                                    <tr>
                                                        <td>Break 1</td>
                                                        <td>
                                                            {{ time_sheet.break1_start_datetime ?
                                                                formatTime(time_sheet.break1_start_datetime) : '00:00' }} -
                                                            {{ time_sheet.break1_end_datetime ?
                                                                formatTime(time_sheet.break1_end_datetime) : '00:00' }}
                                                        </td>
                                                        <td>{{ time_sheet.break1_start_datetime ?
                                                            getDuration(time_sheet.break1_start_datetime,
                                                                time_sheet.break1_end_datetime) : '0 Hrs' }}</td>
                                                    </tr>
                                                    <tr
                                                        v-if="(time_sheet.employee_type == 'Full Time') ? (storeStaffInfo.ft_total_breaks == 2) : (storeStaffInfo.pt_total_breaks == 2)">
                                                        <td>Break 2</td>
                                                        <td>
                                                            {{ time_sheet.break2_start_datetime ?
                                                                formatTime(time_sheet.break2_start_datetime) : '00:00' }} -
                                                            {{ time_sheet.break2_end_datetime ?
                                                                formatTime(time_sheet.break2_end_datetime) : '00:00' }}
                                                        </td>
                                                        <td>{{ time_sheet.scheduled_break_start_time_2 ?
                                                            getDuration(time_sheet.scheduled_break_start_time_2,
                                                                time_sheet.scheduled_break_end_time_2) : '0 Hrs' }}</td>
                                                    </tr>

                                                    <tr>&nbsp;</tr>

                                                    <tr>
                                                        <td class="font-bold">Scheduled</td>
                                                        <td>
                                                            {{ time_sheet.scheduled_start_time ?
                                                                formatTime(time_sheet.scheduled_start_time) : '00:00' }} -
                                                            {{ time_sheet.scheduled_end_time ?
                                                                formatTime(time_sheet.scheduled_end_time) : '00:00' }}
                                                        </td>
                                                        <td>{{ time_sheet.scheduled_start_time ?
                                                            getDuration(time_sheet.scheduled_start_time,
                                                                time_sheet.scheduled_end_time) : '0 Hrs' }}</td>
                                                    </tr>
                                                    <tr>
                                                        <td>Break 1</td>
                                                        <td>
                                                            {{ time_sheet.scheduled_break_start_time_1 ?
                                                                formatTime(time_sheet.scheduled_break_start_time_1) : '00:00' }} -
                                                            {{ time_sheet.scheduled_break_end_time_1 ?
                                                                formatTime(time_sheet.scheduled_break_end_time_1) : '00:00' }}
                                                        </td>
                                                        <td>{{ time_sheet.scheduled_break_start_time_1 ?
                                                            getDuration(time_sheet.scheduled_break_start_time_1,
                                                                time_sheet.scheduled_break_end_time_1) : '0 Hrs' }}</td>
                                                    </tr>
                                                    <tr
                                                        v-if="(time_sheet.employee_type == 'Full Time') ? (storeStaffInfo.ft_total_breaks == 2) : (storeStaffInfo.pt_total_breaks == 2)">
                                                        <td>Break 2</td>
                                                        <td>
                                                            {{ time_sheet.scheduled_break_start_time_2 ?
                                                                formatTime(time_sheet.scheduled_break_start_time_2) : '00:00' }} -
                                                            {{ time_sheet.scheduled_break_end_time_2 ?
                                                                formatTime(time_sheet.scheduled_break_end_time_2) : '00:00' }}
                                                        </td>
                                                        <td>{{ time_sheet.scheduled_break_start_time_2 ?
                                                            getDuration(time_sheet.scheduled_break_start_time_2,
                                                                time_sheet.scheduled_break_end_time_2) : '0 Hrs' }}</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                        <i slot="reference" class="el-icon-info text-lg cursor-pointer"></i>
                                    </el-popover>
                                </span>
                                <template v-if="time_sheet.is_absent">
                                    <span class="mr-2"> Absent </span>
                                </template>
                                <template v-else>
                                    <span class="mr-2"> {{ time_sheet.actual_in ? formatTimeUTC(time_sheet.actual_in) : '00:00'
                                    }} </span>
                                    <span class="mx-2"> - </span>
                                    <span class="ml-2"> {{ time_sheet.actual_out ? formatTimeUTC(time_sheet.actual_out) :
                                        '00:00' }} </span>
                                </template>
                            </div>
                            <div>
                                <span style="margin-right: 14px;">Scheduled: </span>
                                <template v-if="time_sheet.leave">
                                    <el-tag class="mr-2" type="danger" size="mini"
                                        effect="plain">Leave</el-tag>
                                    <!-- <span class="mr-2"> Leave </span> -->
                                </template>
                                <template v-else-if="time_sheet.weekoff">
                                    <el-tag class="mr-2" type="danger" size="mini"
                                        effect="plain">Week Off</el-tag>
                                    <!-- <span class="mr-2"> Week Off </span> -->
                                </template>
                                <template v-else>
                                    <span class="mr-2"> {{ time_sheet.scheduled_start_time ?
                                        formatTime(time_sheet.scheduled_start_time) : '00:00' }} </span>
                                    <span class="mx-2"> - </span>
                                    <span class="ml-2"> {{ time_sheet.scheduled_end_time ?
                                        formatTime(time_sheet.scheduled_end_time) : '00:00' }} </span>
                                </template>
                            </div>
                        </td>
                        <td>
                           <div class="mb-3">
                                <!-- <span style="margin-right: 14px;">Regularized: </span> -->
                                <span class="font-semibold">
                                    {{ time_sheet.regularized_in ?
                                                                getDuration(time_sheet.regularized_in,
                                                                    time_sheet.regularized_out) : '0 Hrs' }}
                                </span>
                            </div>
                           <div class="mb-3">
                                <!-- <span style="margin-right: 14px;">Actual: </span> -->
                                <span class="font-semibold">
                                    {{ time_sheet.actual_in ?
                                                                getDuration(time_sheet.actual_in,
                                                                    time_sheet.actual_out) : '0 Hrs' }}
                                </span>
                            </div>
                           <div>
                                <!-- <span style="margin-right: 14px;">Scheduled: </span> -->
                                <span class="font-semibold">
                                    {{ time_sheet.scheduled_start_time ?
                                                                 getDuration(time_sheet.scheduled_start_time,
                                                                time_sheet.scheduled_end_time) : '0 Hrs' }}
                                </span>
                            </div>
                        </td>
                        <td>
                            <el-popover placement="top" title="Location view" width="500" trigger="hover"
                                :popper-class="time_sheet.uId"
                                @show="time_sheet.shift_start_lat ? showPopover({ start_lat: time_sheet.shift_start_lat, start_lng: time_sheet.shift_start_long, end_lat: time_sheet.shift_end_lat, end_lng: time_sheet.shift_end_long, id: time_sheet.uId }) : ''">
                                <div v-if="time_sheet.shift_start_lat" :id="'map-' + time_sheet.uId" style="height: 350px;">
                                    <!-- Google map -->
                                </div>
                                <div v-else>
                                    <p class="text-center">Location details not found</p>
                                </div>
                                <span slot="reference" class="flex items-center">
                                    <i class="el-icon-location text-xl cursor-pointer mr-2"></i> View Location
                                </span>
                            </el-popover>
                        </td>
                        <td>
                            <div class="mb-2">
                                <span style="margin-right: 33px;" class="font-semibold">Actual:</span>
                                <i class="el-icon-wallet text-amplitude text-sm mr-1"></i> <strong>{{
                                    time_sheet.actual_total_cost ? time_sheet.actual_total_cost : '0' }}</strong>
                            </div>
                            <div class="">
                                <span style="margin-right: 6.6px;">Scheduled: </span>
                                <i class="el-icon-wallet text-amplitude text-sm mr-1"></i> <strong>{{
                                    time_sheet.scheduled_total_cost ? time_sheet.scheduled_total_cost : '0' }}</strong>
                            </div>
                        </td>
                        <td>
                            <el-tag v-if="time_sheet.is_approved" type="success" size="mini"
                                effect="plain">Approved</el-tag>
                            <el-tag v-else type="warning" class="cursor-pointer" size="mini" effect="plain" @click="singleApprove(time_sheet)">Pending</el-tag>
                        </td>
                    </tr>
                </tbody>
            </table>
            <div v-if="computedTimeSheetData.some((e) => e.is_select)" class="ns-bottom-action-strip sticky bg-white">
                <p class="font-semibold text-sm mr-5">Selected Count: {{ computedTimeSheetData.filter((e) =>
                    e.is_select).length }}</p>
                <p class="font-bold text-sm mr-5 cursor-pointer" @click="cancelAll()">Cancel</p>
                <el-button size="medium" class="ns-approve-btn mx-5" @click="approveAll()">Approve Selected</el-button>
            </div>
            <div v-if="!computedTimeSheetData.length" class="w-full">
                <el-empty description="Data not found !"></el-empty>
            </div>
        </div>

        <!-- Edit dialog -->
        <el-dialog v-if="emp_shift_edit_dialog" v-loading="emp_shift_edit_dialog_loading" title="Update Timesheet"
            :visible.sync="emp_shift_edit_dialog" width="50%" custom-class="ns-dialog" :before-close="handleClose">
            <div class="ts-mng-modal">
                <div class="text-sm font-semibold mt-4 ns-avatar-sec">
                    <img class="ns-img-avatar mr-3" :src="avatar" alt="Avatar">
                    <div>
                        <span>{{ emp_shift_data.employee_full_name }}</span>
                        <p class="mt-2 text-xs" style="color: #a1a1a1">{{ emp_shift_data.employee_department }}</p>
                        <!-- <p class="text-xs font-normal">Emp Id - 3250</p> -->
                    </div>
                </div>
                <!-- Schedule -->
                <p class="text-sm font-semibold text-black mt-8">Scheduled Information</p>
                <div class="border rounded mt-3 p-5 text-center">
                    <el-row :gutter="10">
                        <el-col :xs="24" :sm="24" :md="6" :lg="4" :xl="4" class="my-2">
                            <span class="font-semibold"> Location </span>
                            <div class="mt-3">
                                <span class="text-sm font-normal" style="font-size:12px; text-transform: capitalize;">{{
                                    getStoreName(emp_shift_data.store) }}</span>
                            </div>
                        </el-col>
                        <el-col :xs="24" :sm="24" :md="6" :lg="4" :xl="4" class="my-2">
                            <span class="font-semibold"> Date </span>
                            <div class="mt-3">
                                <span class="text-sm font-normal" style="font-size:12px">{{ emp_shift_data.shift_date |
                                    formatDate }}</span>
                            </div>
                        </el-col>
                        <el-col :xs="24" :sm="24" :md="6" :lg="4" :xl="4" class="my-2">
                            <span class="font-semibold"> Time </span>
                            <div class="mt-3">
                                <span class="text-sm font-normal" style="font-size:12px">
                                    <div class="mb-2">Start : {{ emp_shift_data.shift_start_datetime | formatTime }}
                                    </div>
                                    <div>End : {{ emp_shift_data.shift_end_datetime | formatTime }}</div>
                                </span>
                            </div>
                        </el-col>
                        <el-col :xs="24" :sm="24" :md="6" :lg="4" :xl="4" class="my-2">
                            <span class="font-semibold"> Breaks </span>
                            <div class="mt-3">
                                <span class="text-sm font-normal" style="font-size:12px">
                                    <div class="mb-2">Start : {{ emp_shift_data.breaklast_start_datetime | formatTime }}
                                    </div>
                                    <div>End : {{ emp_shift_data.breaklast_end_datetime | formatTime }}</div>
                                </span>
                            </div>
                        </el-col>
                        <el-col :xs="24" :sm="24" :md="6" :lg="4" :xl="4" class="my-2">
                            <span class="font-semibold"> Break Duration </span>
                            <div class="mt-3">
                                <span class="text-sm font-normal" style="font-size:12px"> - </span>
                            </div>
                        </el-col>
                        <el-col :xs="24" :sm="24" :md="6" :lg="4" :xl="4" class="my-2">
                            <span class="font-semibold"> Total Duration </span>
                            <div class="mt-3">
                                <span class="text-sm font-normal" style="font-size:12px">{{ emp_shift_data.total_duration
                                }}</span>
                            </div>
                        </el-col>
                    </el-row>
                </div>

                <!-- Timesheet -->
                <p class="text-sm font-semibold text-black mt-8">Timesheet</p>
                <div class="border rounded mt-3 p-5">
                    <el-row :gutter="10">
                        <el-col :xs="24" :sm="24" :md="6" :lg="3" :xl="3" class="my-2">
                            <p class="font-semibold mt-3"> Status </p>
                        </el-col>
                        <el-col :xs="24" :sm="24" :md="6" :lg="6" :xl="6" class="my-2"
                            style="padding-right: 13px !important;">
                            <el-select v-model="shiftOpt" style="width:100%" placeholder="Select">
                                <el-option v-for="item in statusOpt" :key="item.value" :label="item.label"
                                    :value="item.value">
                                </el-option>
                            </el-select>
                        </el-col>
                    </el-row>
                    <template v-if="shiftOpt === 'shift'">
                        <el-row :gutter="20">
                            <el-col :xs="24" :sm="24" :md="6" :lg="3" :xl="3" class="my-3">
                                <p class="font-semibold mt-8"> Actual Time </p>
                            </el-col>
                            <el-col :xs="24" :sm="24" :md="6" :lg="6" :xl="6" class="my-3">
                                <p class="text-sm font-semibold mb-1" style="font-size:12px">In Time</p>
                                <!-- <el-time-picker v-model="emp_shift_data.actual_in" :picker-options="{
                                    format: ('HH:mm')
                                }" format="hh:mm A" placeholder="In time">
                                </el-time-picker> -->
                                <DateTimePicker v-model="emp_shift_data.actual_in"
                                    v-validate="emp_shift_edit_dialog ? 'required' : ''"
                                    :displayed-value="emp_shift_data.actual_in" name="In time"
                                    :shift-time-slots="shift_start_time_slot" label="In time"
                                    @change="updatedInTime(emp_shift_data.actual_in)" />
                            </el-col>
                            <el-col :xs="24" :sm="24" :md="6" :lg="6" :xl="6" class="my-3">
                                <p class="text-sm font-semibold mb-1" style="font-size:12px">Out Time</p>
                                <!-- <el-time-picker v-model="emp_shift_data.actual_out" :picker-options="{
                                    format: ('HH:mm')
                                }" format="hh:mm A" placeholder="In time">
                                </el-time-picker> -->
                                <DateTimePicker v-model="emp_shift_data.actual_out"
                                    v-validate="emp_shift_edit_dialog ? 'required' : ''"
                                    :displayed-value="emp_shift_data.actual_out" name="Out time"
                                    :shift-time-slots="shift_end_time_slot" :disabled-condition="emp_shift_data.actual_in"
                                    label="Out time" />
                            </el-col>
                            <el-col :xs="24" :sm="24" :md="4" :lg="4" :xl="4" class="my-3 ml-5">
                                <p class="text-sm font-semibold mb-1" style="font-size:12px">Shift Duration</p>
                                <div class="mt-3">
                                    <span class="text-sm font-normal" style="font-size:12px">{{ shiftDuration }} Hrs</span>
                                </div>
                            </el-col>
                        </el-row>
                        <!-- Breaks -->
                        <el-row :gutter="20">
                            <el-col :xs="24" :sm="24" :md="6" :lg="3" :xl="3" class="my-3">
                                <p class="font-semibold mt-8"> Break </p>
                            </el-col>
                            <el-col :xs="24" :sm="24" :md="6" :lg="6" :xl="6" class="my-3">
                                <p class="text-sm font-semibold mb-1" style="font-size:12px">Start Time</p>
                                <!-- <el-time-picker v-model="emp_shift_data.actual_break_start" :picker-options="{
                                    format: ('HH:mm')
                                }" format="hh:mm A" placeholder="In time">
                                </el-time-picker> -->
                                <DateTimePicker v-model="emp_shift_data.actual_break_start"
                                    v-validate="emp_shift_edit_dialog ? 'required' : ''" name="Break Start time"
                                    :displayed-value="emp_shift_data.actual_break_start"
                                    :shift-time-slots="shift_end_time_slot" label="Break Start Time"
                                    @change="updatedBreakStartTime(emp_shift_data.actual_break_start)" />
                            </el-col>
                            <el-col :xs="24" :sm="24" :md="6" :lg="6" :xl="6" class="my-3">
                                <p class="text-sm font-semibold mb-1" style="font-size:12px">End Time</p>
                                <!-- <el-time-picker v-model="emp_shift_data.actual_break_end" :picker-options="{
                                    format: ('HH:mm')
                                }" format="hh:mm A" placeholder="In time">
                                </el-time-picker> -->
                                <DateTimePicker v-model="emp_shift_data.actual_break_end"
                                    v-validate="emp_shift_edit_dialog ? 'required' : ''"
                                    :displayed-value="emp_shift_data.actual_break_end" name="Break End time"
                                    :shift-time-slots="break_end_time_slot" label="Break End Time" />
                            </el-col>
                            <el-col :xs="24" :sm="24" :md="4" :lg="4" :xl="4" class="my-3 ml-5">
                                <p class="text-sm font-semibold mb-1" style="font-size:12px">Break Duration</p>
                                <div class="mt-3">
                                    <span class="text-sm font-normal" style="font-size:12px">{{ breakDuration }} Hrs</span>
                                </div>
                            </el-col>
                        </el-row>
                    </template>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button class="ns-cancel-btn" @click="handleClose">Cancel</el-button>
                <el-button v-if="!emp_shift_data.is_approved" class="ns-approve-btn"
                    @click="approveData">Approve</el-button>
                <el-button v-else class="ns-approved-btn">Approved</el-button>
            </span>
        </el-dialog>
        <!-- Edit dialog -->
    </div>
</template>

<script>
import api from "../../../services/labourPalnningService";
import axios from "axios";
import moment from 'moment';
import DateTimePicker from "../elements/DateTimePicker.vue";
import { EventBus } from "../../../eventBus";
import exportFromJSON from 'export-from-json';
import { mapActions } from "vuex";
export default {
    name: "ManageTimeSheetV2",
    components: {
        DateTimePicker
    },
    filters: {
        formatDate(date) {
            return moment(date).format('Do MMM YYYY')
        },
        formatTime(time) {
            if (!time) {
                return '-';
            }
            return moment(time).format('hh:mm A')
        }
    },
    props: {
        selectedStore: {
            type: String,
            default: () => ''
        },
        startDate: {
            type: String,
            default: () => ''
        },
        endDate: {
            type: String,
            default: () => ''
        },
        searchEmp: {
            type: String,
            default: () => ''
        },
        storeList: {
            type: Array,
            default: () => []
        },
    },
    data() {
        return {
            time_sheet_list: [],
            all_dates: [],
            selected_date: [],
            time_sheet_summary: {},
            store_timing: {},
            is_time_sheet_loading: false,
            emp_shift_edit_dialog: false,
            emp_shift_edit_dialog_loading: false,
            search_emp_by_id_name: '',
            emp_shift_data: {},
            shift_start_time_slot: [],
            shift_end_time_slot: [],
            break_end_time_slot: [],
            break_start_time_slot: [],
            statusOpt: [
                {
                    label: 'Shift Time',
                    value: 'shift'
                },
                // {
                //     label: 'Weekly Off',
                //     value: 'weekly_off'
                // },
                // {
                //     label: 'Leave',
                //     value: 'leave'
                // },
                {
                    label: 'Absent',
                    value: 'no_shift'
                }
            ],
            shiftOpt: '',
            avatar: '',
            select_all: false,
            popover_loading: false,
            storeStaffInfo: {},
            map: null,
            marker: null,
            startInfoWindow: null,
            endInfoWindow: null,
            selected_department_list: [],
            selected_availability: [],
            availabilityOpt: ["Scheduled", "Actual", "Regularized", "Weekly Off", "Leave", "Absent"],
            statusOptList: ["Approve", "Pending"],
            selected_status_list: []
        }
    },
    computed: {
        computedTimeSheetData() {
            let data = [...this.time_sheet_list];

            if (this.searchEmp) {
                data = data.filter(item =>
                    item.employee_full_name.toLowerCase().includes(this.searchEmp.toLowerCase()) ||
                    item.employee_code.toString().includes(this.searchEmp)
                );
            }

            if (this.selected_date.length) {
                data = data.filter(item =>
                    this.selected_date.includes(moment(item.shift_date).format('YYYY-MM-DD'))
                );
            }

            if (this.selected_department_list.length) {
                data = data.filter(item =>
                    this.selected_department_list.includes(item.employee_department)
                );
            }

            if (this.selected_status_list.length) {
                data = data.filter(item => {
                    return this.selected_status_list.some(i => {
                        if (i === 'Approve') {
                            return item.is_approved;
                        } else if (i === 'Pending') {
                            return !item.is_approved;
                        }
                    });
                });
            }

            if (this.selected_availability.length) {
                data = data.filter(item => {
                    return this.selected_availability.some(i => {
                        if (i === 'Weekly Off') {
                            return item.weekoff;
                        } else if (i === 'Leave') {
                            return item.leave;
                        } else if (i === 'Scheduled') {
                            return item.scheduled_start_time && item.scheduled_end_time;
                        } else if (i === 'Actual') {
                            return item.actual_in && item.actual_out;
                        } else if (i === 'Regularized') {
                            return item.regularized_in && item.regularized_out;
                        } else if (i === 'Absent') {
                            return item.scheduled_start_time && item.scheduled_end_time && !(item.actual_in && item.actual_out);
                        }
                    });
                });
            }

            data.forEach(elm => {
                elm.is_select = false;
            });

            return data;
        },
        generateEndTimeSlot() {
            const start = moment(this.emp_shift_data.shift_start_datetime).format("HH:mm")
            '00:00 - 24:00'
            return start + ' - 24:00'
        },
        employeeDepartments() {
            let arr = [];
            this.time_sheet_list.map((e) => arr.push(e.employee_department));
            return [...new Set(arr)];
        },
        shiftDuration() {
            if (this.emp_shift_data.actual_in && this.emp_shift_data.actual_out) {
                const startTime = moment(this.emp_shift_data.actual_in);
                const endTime = moment(this.emp_shift_data.actual_out);
                const diffInMillis = endTime.diff(startTime);
                const duration = moment.duration(diffInMillis);
                const hours = Math.floor(duration.asHours());
                const minutes = duration.minutes();

                // Format the result as HH:mm
                const formattedDiff = `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}`;
                return formattedDiff;
            }
            return '-'
        },
        breakDuration() {
            if (this.emp_shift_data.actual_break_start && this.emp_shift_data.actual_break_end) {
                const startTime = moment(this.emp_shift_data.actual_break_start);
                const endTime = moment(this.emp_shift_data.actual_break_end);
                const diffInMillis = endTime.diff(startTime);
                const duration = moment.duration(diffInMillis);
                const hours = Math.floor(duration.asHours());
                const minutes = duration.minutes();

                // Format the result as HH:mm
                const formattedDiff = `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}`;
                return formattedDiff;
            }
            return '-'
        }
    },
    watch: {
        selectedStore(newValue, oldValue) {
            if (newValue) {
                this.getTodaysTimeSheetDetails();
            }
        }
    },
    mounted() {
        this.getTodaysTimeSheetDetails();
        EventBus.$on('loadAllApis', (data) => {
            this.getTodaysTimeSheetDetails();
        });
        EventBus.$on('exportCSV', () => {
            this.exportCSV();
        });
        // document.addEventListener('click', this.closeAllTimeSheetEdit()); 
    },
    beforeDestroy() {
        EventBus.$off('loadAllApis');
        EventBus.$off('exportCSV');
        // document.addEventListener('click', this.closeAllTimeSheetEdit()); 
    },
    methods: {
        ...mapActions("CommonStore", ["addDownloadingReportCountAction", "removeDownloadingReportCountAction"]),
        generateTimeSlotsForDateTimePickerByFunc(startTime, endTime, slotInterval, is_for) {
            const timeSlots = [];

            const startMoment = moment(startTime);
            const endMoment = moment(endTime);

            while (startMoment.isSameOrBefore(endMoment)) {
                const timeSlot = {
                    label: startMoment.format('h:mm A'),
                    value: startMoment.format('YYYY-MM-DDTHH:mm:ss'),
                };

                timeSlots.push(timeSlot);
                startMoment.add(slotInterval, 'minutes');
            }
            console.log(timeSlots, startTime, endTime, slotInterval, 'startTime, endTime, slotInterval  ')
            this[is_for] = timeSlots;
        },
        showPopover(loc_details) {
            // Ensure the Google Maps API is loaded
            if (typeof google === "undefined" && !(loc_details.start_lat && loc_details.end_lat)) {
                return;
            }

            // Get the locations' latitude and longitude
            const locationStart = { lat: loc_details.start_lat, lng: loc_details.start_lng }; // Replace with your actual demo data
            const locationEnd = { lat:  loc_details.end_lat, lng: loc_details.end_lng }; // Replace with your actual demo data
            // Set Lat Lang
            // loc_details.start_lat ? locationStart.start_lat = loc_details.start_lat : '';
            // loc_details.start_lng ? locationStart.start_lng = loc_details.start_lng : '';
            // loc_details.end_lat ? locationEnd.end_lat = loc_details.end_lat : '';
            // loc_details.end_lng ? locationEnd.end_lng = loc_details.end_lng : '';
            // const locationStart = { lat: loc_details.start_lat, lng: loc_details.start_lng };
            // const locationEnd = { lat: loc_details.end_lat, lng: loc_details.end_lng };

            // Initialize the map if it's not already initialized
            //   if (!this.map) {
            //     this.map = new google.maps.Map(document.getElementById(`map-${loc_details.id}`), {
            //       center: locationStart,
            //       zoom: 15,
            //     });
            //   }
            console.log(locationStart,locationEnd, 'loc_details')
            this.map = new google.maps.Map(document.getElementById(`map-${loc_details.id}`), {
                center: locationStart,
                zoom: 15,
            });

            // Add markers to the map
            if (this.markerStart) {
                this.markerStart.setMap(null);
            }
            if (this.markerEnd) {
                this.markerEnd.setMap(null);
            }

            // Create markers for start and end locations
            this.markerStart = new google.maps.Marker({
                position: locationStart,
                map: this.map,
                title: "Location Start",
                icon: "http://maps.google.com/mapfiles/ms/icons/green-dot.png", // Green marker for start location
            });

            this.markerEnd = new google.maps.Marker({
                position: locationEnd,
                map: this.map,
                title: "Location End",
                icon: "http://maps.google.com/mapfiles/ms/icons/red-dot.png", // Red marker for end location
            });

            // Create tooltips for start and end location markers
            if (true) { //!this.startInfoWindow
                this.startInfoWindow = new google.maps.InfoWindow({
                    content: "Start Location", // Replace with custom content if needed
                });

                // Show tooltip on marker hover
                this.markerStart.addListener("mouseover", () => {
                    this.startInfoWindow.open(this.map, this.markerStart);
                });

                // Hide tooltip when mouseout
                this.markerStart.addListener("mouseout", () => {
                    this.startInfoWindow.close();
                });
            }

            if (true) { //!this.endInfoWindow
                this.endInfoWindow = new google.maps.InfoWindow({
                    content: "End Location", // Replace with custom content if needed
                });

                // Show tooltip on marker hover
                this.markerEnd.addListener("mouseover", () => {
                    this.endInfoWindow.open(this.map, this.markerEnd);
                });

                // Hide tooltip when mouseout
                this.markerEnd.addListener("mouseout", () => {
                    this.endInfoWindow.close();
                });
            }

            // Set the popover content with location details
            const popoverContent = `
        <div>
          <strong>Location Start:</strong> ${locationStart.lat.toFixed(6)}, ${locationStart.lng.toFixed(6)}
          <br />
          <strong>Location End:</strong> ${locationEnd.lat.toFixed(6)}, ${locationEnd.lng.toFixed(6)}
        </div>
      `;

            this.$nextTick(() => {
                if (this.$refs.popover) {
                    this.$refs.popover.$el.querySelector(".el-popover__title").innerHTML = popoverContent;
                }
            });
        },
        exportCSV() {
            this.addDownloadingReportCountAction();
            let data = this.time_sheet_list.map((el) => ({
                "Employee ID": el.employee_code,
                "Employee Name": el.employee_full_name,
                "Department": el.employee_department,
                "Location ID": el.store_code,
                "Location Name": this.getStoreName(el.store),
                "Schedule Date": moment(el.shift_date).format('YYYY-MM-DD'),
                "Scheduled In Time": el.scheduled_start_time ? moment(el.scheduled_start_time).format("hh:mm A") : '',
                "Scheduled Out Time": el.scheduled_end_time ? moment(el.scheduled_end_time).format("hh:mm A") : '',
                "Actual In Time": el.actual_in ? moment.utc(el.actual_in).local().format("hh:mm A") : '',
                "Actual Out Time": el.actual_out ? moment.utc(el.actual_out).local().format("hh:mm A") : '',
                "Regularized In": el.regularized_in ? moment(el.regularized_in).format("hh:mm A") : '',
                "Regularized Out": el.regularized_out ? moment(el.regularized_out).format("hh:mm A") : '',
                "Scheduled Break Start Time": el.scheduled_break_start_time ? moment(el.scheduled_break_start_time).format("hh:mm A") : '',
                "Scheduled Break End Time": el.scheduled_break_end_time ? moment(el.scheduled_break_end_time).format("hh:mm A") : '',
                "Actual Break Start Time": el.breaklast_start_datetime ? moment(el.breaklast_start_datetime).format("hh:mm A") :'',
                "Actual Break End Time": el.breaklast_end_datetime ? moment(el.breaklast_end_datetime).format("hh:mm A") : '',
                "Regularized Break In Time": el.regularized_break_in ? moment(el.regularized_break_in).format("hh:mm A") : '',
                "Regularized Break Out Time": el.regularized_break_out ? moment(el.regularized_break_out).format("hh:mm A") : '',
                "Schedule Cost": el.scheduled_total_cost,
                "Actual Cost": el.actual_total_cost,
                "Duration": el.total_duration,
                "Status": el.is_approved ? 'Approved' : el.leave ? 'Leave' : el.weekoff ? 'Weekly Off' : 'Pending'
            }));
            const fileName =
                "TimeSheet_" + this.startDate + "_to_" + this.endDate;
            const exportType = exportFromJSON.types.csv;
            exportFromJSON({ data, fileName, exportType });
            this.removeDownloadingReportCountAction();
        },
        timeSheetChanged(id) {
            let check = this.computedTimeSheetData.find((e) => e.uId === id).action_type === this.time_sheet_list.find((e) => e.uId === id).action_type;
            if (check) {
                this.computedTimeSheetData.map((e) => {
                    if (e.uId === id) {
                        if (check)
                            e.is_changed = true;
                        else
                            e.is_changed = false;
                    }
                });
                this.$forceUpdate();
            }
        },
        formatTime(time) {
            if (!time) {
                return '-';
            }
            return moment(time).format('hh:mm A')
        },
        formatTimeUTC(time) {
            if (!time) {
                return '-';
            } else if(time === 'NaT') {
                return 'No Check Out';
            }
            return moment.utc(time).local().format('hh:mm A')
        },
        selectAllOpt(event) {
            this.time_sheet_list.map((e) => {
                if(!e.is_approved){
                    e.is_select = event;
                }
            });
        },
        getDuration(start, end) {
            if (start && end) {
                const startTime = moment(start);
                const endTime = moment(end);
                const diffInMillis = endTime.diff(startTime);
                const duration = moment.duration(diffInMillis);
                const hours = Math.floor(duration.asHours());
                const minutes = duration.minutes();

                // Format the result as HH:mm
                const formattedDiff = `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')} Hrs`;
                return isNaN(hours) ? '0 Hrs' : formattedDiff;
            }
            return '-'
        },
        getStoreStaffInfo() {
            const params = {
                outlet_id: this.selectedStore
            }
            api.getStoreStaffInfo(params)
                .then(response => {
                    let responseData = JSON.parse(response.data);
                    this.storeStaffInfo = responseData;
                }).catch(error => {
                    console.error(error);
                })
        },
        cancelAll(event) {
            this.computedTimeSheetData.map((e) => {
                e.is_select = false;
            });
            this.select_all = false;
            this.$forceUpdate();
        },
        singleApprove(timesheet) {
            let params = {
                    id: null,
                    approved: true
                };
            if (timesheet.timesheet_id) {
                params.id = timesheet.timesheet_id;
            } else if(timesheet.employee_code) {
                params.employee_code = timesheet.employee_code;
                params.for_date = moment(timesheet.shift_date).format("YYYY-MM-DD");
            } else {
                this.$notify.error({
                    title: "Opps Something went wrong",
                    message: "Timesheet not available"
                });
                return;
            }

            this.popover_loading = true;
            api.changeTimeSheetStatusNetworkCallBack(params)
                .then(response => {
                    if (response.status == 200) {
                        this.getTodaysTimeSheetDetails();
                        this.$notify.success({
                            title: "Successful",
                            message: "Timesheet approved successfully"
                        });
                        this.popover_loading = false;   //disabled loader
                        this.closeAllTimeSheetEdit();
                    }
                    this.popover_loading = false;
                })
                .catch(e => {
                    this.popover_loading = false;
                    console.log('error', e);
                });
        },
        approveAll(event) {
            // Prepare Payload
            let params = {
                "timesheets": []
            };
            // Checkpoint
            // this.computedTimeSheetData.map((elm)=>{
            //     if(elm.timesheet_id && elm.is_select) {
            //         params.timesheets.push({id: elm.timesheet_id, approved: true});
            //     }
            // })
            for (let elm of this.computedTimeSheetData) {
                if (elm.timesheet_id && elm.is_select && !elm.is_approved) {
                    params.timesheets.push({ id: elm.timesheet_id, approved: true });
                } else if(elm.is_select && !elm.is_approved) {
                    params.timesheets.push({ id: null, employee_code: elm.employee_code, for_date: moment(elm.shift_date).format("YYYY-MM-DD"), approved: true });
                    // console.log(params, 'params');
                }
            }
            if (!params.timesheets.length) {
                this.$notify.error({
                    title: "Opps Something went wrong",
                    message: "Timesheet not available"
                });
                return;
            } else {
                console.log(params, 'params');
                // return;
                this.emp_shift_edit_dialog_loading = true;
                api.approveAllTimeSheet(params)
                    .then(response => {
                        this.getTodaysTimeSheetDetails();
                        // this.getTodaysTimesheetDetails();   //called api to get updated status
                        this.$notify.success({
                            title: "Successful",
                            message: "Timesheet approved successfully"
                        });
                        this.emp_shift_edit_dialog_loading = false;
                    })
                    .catch(e => {
                        this.emp_shift_edit_dialog_loading = false;
                        console.log('error', e);
                    });
            }
        },
        selectOpt() {
            this.$forceUpdate();
        },
        generateTimeSlots(intervalMinutes, startTime) {
            console.log(intervalMinutes, startTime, 'intervalMinutes, startTime');
            const timeSlots = [];
            const intervalMs = intervalMinutes * 60 * 1000;

            const startDateTime = new Date(startTime);
            const endDateTime = new Date(startDateTime.getTime() + (24 * 60 * 60 * 1000)); // Set end time to 24 hours after start time

            while (startDateTime < endDateTime) {
                const timeLabel = startDateTime.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
                const timeValue = startDateTime.toISOString();

                let ampm = 'AM'; // Initialize as AM
                const hours = startDateTime.getHours();
                
                // Check if it's PM and update ampm accordingly
                if (hours >= 12) {
                    ampm = 'PM';
                }

                timeSlots.push({
                    label: moment(timeLabel, 'HH:mm').format("hh:mm") + ' ' + ampm,
                    value: moment(timeValue).format("YYYY-MM-DDTHH:mm:ss")
                });

                startDateTime.setTime(startDateTime.getTime() + intervalMs);
            }

            return timeSlots;
        },
        updatedInTime(changedTime) {
            this.emp_shift_data.actual_out = '';
            this.shift_end_time_slot = this.generateTimeSlots(1, changedTime);
        },
        updatedBreakStartTime(changedTime) {
            // this.emp_shift_data.actual_break_end = '';
            this.break_end_time_slot = this.generateTimeSlots(1, changedTime);
        },
        generateUUID() {
            // Generate a random array of 16 bytes (128 bits)
            const array = new Uint8Array(16);
            crypto.getRandomValues(array);

            // Set the version (4) and variant bits (10xx) as per the UUID specification
            array[6] = (array[6] & 0x0f) | 0x40;
            array[8] = (array[8] & 0x3f) | 0x80;

            // Convert the byte array to a hexadecimal UUID string
            let uuid = '';
            for (let i = 0; i < 16; i++) {
                uuid += (array[i] < 16 ? '0' : '') + array[i].toString(16);
            }

            // Insert the dashes at appropriate positions to form the UUID format
            uuid = `${uuid.substr(0, 8)}-${uuid.substr(8, 4)}-${uuid.substr(12, 4)}-${uuid.substr(16, 4)}-${uuid.substr(20)}`;

            return uuid;
        },
        getTodaysTimeSheetDetails(empId, tsDate) {
            if (this.selectedStore) {
                this.getStoreStaffInfo();
                this.is_time_sheet_loading = true;
                let timesheet_params = {
                    start_date: this.startDate,
                    end_date: this.endDate,
                    filters: {
                        outlets: [this.selectedStore],
                        regions: [],
                        subregions: [],
                        countries: []
                    }
                };

                let store_time_params = {
                    start_date: this.startDate,
                    end_date: this.endDate,
                    outlet: this.selectedStore
                };
                // Get all dates
                // this.getDatesBetween();

                axios.all([this.completeTimeSheetDetails(timesheet_params), this.getStoreTime(store_time_params)])
                    .then(axios.spread((timesheetRes, storeTimeRes) => {
                        if (timesheetRes.status == 200 && storeTimeRes.status == 200) {
                            this.time_sheet_list = JSON.parse(timesheetRes.data).timesheets.length ? JSON.parse(timesheetRes.data).timesheets : [];
                            // Generate unique time
                            if (this.time_sheet_list.length) {
                                for (let el of this.time_sheet_list) {
                                    // el.uId = Math.floor(1000 + Math.random() * 9000000000);
                                    el.uId = el.employee_id + el.shift_date;
                                    // Add action_type
                                    el.action_type = el.leave ? 'leave'
                                        : el.weekoff ? 'weekly_off'
                                            : el.no_shift ? 'no_shift'
                                                : el.shift_start_datetime || el.shift_end_datetime ? 'shift'
                                                    : 'shift';
                                }
                            }

                            this.time_sheet_summary = JSON.parse(timesheetRes.data).summary;
                            this.$store.commit('commitTimesheetSummary', this.time_sheet_summary);
                            this.store_timing = JSON.parse(storeTimeRes.data);
                        }
                        // Approve if approve req param available
                        if(empId && tsDate && this.time_sheet_list){
                            const tsId = this.time_sheet_list.find((e)=> e.employee_id === empId && e.shift_date === tsDate);
                            this.approveData(tsId.timesheet_id);
                        }
                    }))
                    .catch(err => {
                        console.log(err);
                        this.is_time_sheet_loading = false;
                    })
                    .finally(() => {
                        this.is_time_sheet_loading = false;
                    });
            }
        },
        async completeTimeSheetDetails(params) {
            try {
                const response = await api.completeTimesheetDetailskNetworkCallBack(params);
                return response;
            } catch (e) {
                console.log('error', e);
                this.is_time_sheet_loading = false;
            }
        },
        async getStoreTime(params) {
            try {
                const response = await api.storeOpenCloseTime(params);
                return response;
            } catch (e) {
                console.log('error', e);
                this.is_time_sheet_loading = false;
            }
        },
        getStoreName(id) {
            let store = { name: '-' };
            if (this.storeList.length) {
                store = this.storeList.find((e) => e.id === id);
            }
            return store.name;
        },
        getDatesBetween() {
            const startDate = new Date(this.startDate);
            const endDate = new Date(this.endDate);

            // Validate the input dates
            if (isNaN(startDate) || isNaN(endDate)) {
                console.log('Invalid date format. Please use YYYY-MM-DD format.');
            }

            // Initialize the result array
            const datesArray = [];

            // Loop through the dates and add them to the array
            while (startDate <= endDate) {
                datesArray.push(new Date(startDate).toISOString().slice(0, 10));
                startDate.setDate(startDate.getDate() + 1);
            }

            this.all_dates = datesArray;
        },
        closeTimeSheetEdit(data) {
            this.time_sheet_list.map((e) => {
                if (e.uId === data.uId) {
                    e.is_editable_popover = false
                }
            });
            this.$forceUpdate();
        },
        closeAllTimeSheetEdit() {
            this.time_sheet_list.map((e) => {
                e.is_editable_popover = false;
            });
            this.$forceUpdate();
        },
        editTimeSheet(data, index) {
            // According to new edit flow
            this.time_sheet_list[index].is_editable = true;
            this.$forceUpdate();
            return;

            this.shift_start_time_slot = this.generateTimeSlots(1, '2023-07-24T00:00:00');
            // Open shift data
            this.emp_shift_data = { ...data };
            this.generateAvatar(this.emp_shift_data.employee_full_name);
            if (data.leave) {
                this.shiftOpt = 'leave'
            } else if (data.weekoff) {
                this.shiftOpt = 'weekly_off'
            } else if (data.no_shift) {
                this.shiftOpt = 'no_shift'
            } else if (data.shift_start_datetime || data.shift_end_datetime) {
                this.shiftOpt = 'shift'
            }
            this.emp_shift_edit_dialog = true;
        },
        editTimeSheetPopover(data, index) {
            // According to new edit flow
            for (let elm of this.time_sheet_list) {
                elm.is_editable_popover = false;
            }
            this.time_sheet_list.map((e) => {
                if (e.uId === data.uId) {
                    e.is_editable_popover = true
                }
            });
            this.$forceUpdate();
            return;

            this.shift_start_time_slot = this.generateTimeSlots(1, '2023-07-24T00:00:00');
            // Open shift data
            this.emp_shift_data = { ...data };
            this.generateAvatar(this.emp_shift_data.employee_full_name);
            if (data.leave) {
                this.shiftOpt = 'leave'
            } else if (data.weekoff) {
                this.shiftOpt = 'weekly_off'
            } else if (data.no_shift) {
                this.shiftOpt = 'no_shift'
            } else if (data.shift_start_datetime || data.shift_end_datetime) {
                this.shiftOpt = 'shift'
            }
            this.emp_shift_edit_dialog = true;
        },
        deleteTimeSheet() {
            if (!this.emp_shift_data.timesheet_id) {
                this.$notify.error({
                    title: "Opps Something went wrong",
                    message: "Timesheet not available"
                });
                return;
            } else {
                this.$confirm('Are you sure you want to leave? All changes will be discarded/deleted.', 'Warning', {
                    confirmButtonText: 'OK',
                    cancelButtonText: 'Cancel',
                    type: 'warning'
                }).then(() => {
                    this.emp_shift_edit_dialog_loading = true;
                    api.deleteTimesheetInBulkNetworkCallBack({ id: this.emp_shift_data.timesheet_id })
                        .then(response => {
                            if (response.status == 200) {
                                this.getTodaysTimesheetDetails();   //called get timesheet api to get updated shifts
                            } else {
                                this.emp_shift_edit_dialog_loading = false;   //disabled loader
                                this.$notify.error({
                                    title: "Fail",
                                    message: "Something Went Wrong"
                                });
                            }
                        })
                        .catch((e) => {
                            console.log('error', e);
                            this.emp_shift_edit_dialog_loading = false;   //disabled loader
                        })
                }).catch(() => {

                });
            }
        },
        saveData(timesheet) {
            if (timesheet.action_type == 'leave') {
                this.updateLeave(timesheet);
            } else if (timesheet.action_type == 'weekly_off') {
                this.updateWeekOff(timesheet);
            } else if (timesheet.regularized_in && timesheet.regularized_out) {
                this.updateTimeSheet(timesheet);
            } else {
                this.singleApprove(timesheet);
            }
        },
        updateWeekOff(timesheet) {
            this.popover_loading = true;
            // Prepare payload
            let payload = {
                "data": [
                    {
                        "date": moment(timesheet.shift_date).format("YYYY-MM-DD"),
                        "employee": timesheet.employee_id,
                        "store": timesheet.store,
                        "is_comp_off": false,
                        "auto_sheduled": false
                    }
                ],
                "store": timesheet.store,
                "start_date": moment(timesheet.shift_date).format("YYYY-MM-DD"),
                "end_date": moment(timesheet.shift_date).format("YYYY-MM-DD")
            }
            api.saveWeeklyOffNetworkCallBack(payload)
                .then(response => {
                    if (response.status == 200) {
                        this.getTodaysTimeSheetDetails();
                        this.popover_loading = false;   //disabled loader
                        this.closeAllTimeSheetEdit();
                        this.$notify.success({
                            title: "Successful",
                            message: "Weekly of added"
                        });
                        this.singleApprove(timesheet);
                    } else {
                        this.popover_loading = false;   //disabled loader
                        this.$notify.error({
                            title: "Fail",
                            message: "Something Went Wrong"
                        });
                    }
                })
                .catch((e) => {
                    console.log('error', e);
                    this.popover_loading = false;   //disabled loader
                })
        },
        updateLeave(timesheet) {
            // Prepare payload
            this.popover_loading = true;
            let payload = {
                "date": moment(timesheet.shift_date).format("YYYY-MM-DD"),
                "employee": timesheet.employee_id,
                "store": timesheet.store,
                "leave_type": "casual_leave",
                "is_paid": true,
                "start_date": moment(timesheet.shift_date).format("YYYY-MM-DD"),
                "end_date": moment(timesheet.shift_date).format("YYYY-MM-DD"),
                "total_days": 1,
                "description": ""
            }
            api.addLeaveOfEmployeeNetworkCallBack(payload)
                .then(response => {
                    if (response.status == 200) {
                        this.getTodaysTimeSheetDetails();
                        this.popover_loading = false;   //disabled loader
                        this.closeAllTimeSheetEdit();
                        this.$notify.success({
                            title: "Successful",
                            message: "Leave added"
                        });
                        this.singleApprove(timesheet);
                    } else {
                        this.popover_loading = false;   //disabled loader
                        this.$notify.error({
                            title: "Fail",
                            message: "Something Went Wrong"
                        });
                    }
                })
                .catch((e) => {
                    console.log('error', e);
                    this.popover_loading = false;   //disabled loader
                })
        },
        updateTimeSheet(timesheet) {
            this.popover_loading = true;
            // Prepare payload
            let payload = {
                employee: timesheet.user_id,
                activity: 'shift_end',
                activity_num: 1,
                datetime: moment().format("YYYY-MM-DDTHH:mm:ss"),
                shift_date: moment(timesheet.shift_date).format("YYYY-MM-DD"),
                outlet: timesheet.store,
                regularized_in: timesheet.regularized_in,
                regularized_out: timesheet.regularized_out,
            }
            if (timesheet.regularized_break_in && timesheet.regularized_break_out) {
                payload.regularized_break_in = timesheet.regularized_break_in;
                payload.regularized_break_out = timesheet.regularized_break_out;
            }
            api.updateTimeSheet(payload)
                .then(response => {
                    if (response.status == 200) {
                        this.$notify.success({
                            title: "Successful",
                            message: "Timesheet updated successfully"
                        });
                        this.popover_loading = false;   //disabled loader
                        this.closeAllTimeSheetEdit();
                        this.getTodaysTimeSheetDetails(timesheet.employee_id , timesheet.shift_date);
                    } else {
                        this.popover_loading = false;   //disabled loader
                        this.$notify.error({
                            title: "Fail",
                            message: "Something Went Wrong"
                        });
                    }
                })
                .catch((e) => {
                    console.log('error', e);
                    this.popover_loading = false;   //disabled loader
                })
        },
        approveData(id) {
            if (!id) {
                this.$notify.error({
                    title: "Opps Something went wrong",
                    message: "Timesheet not available"
                });
                return;
            } else {
                this.popover_loading = true;
                let params = {
                    id: id,
                    approved: true
                };
                api.changeTimeSheetStatusNetworkCallBack(params)
                    .then(response => {
                        if (response.status == 200) {
                            this.getTodaysTimeSheetDetails();
                            this.$notify.success({
                                title: "Successful",
                                message: "Timesheet approved successfully"
                            });
                            this.popover_loading = false;   //disabled loader
                            this.closeAllTimeSheetEdit();
                        }
                        this.popover_loading = false;
                    })
                    .catch(e => {
                        this.popover_loading = false;
                        console.log('error', e);
                    });
            }
        },
        generateAvatar(empName) {
            const names = empName.split(' ');
            const firstLetter = names[0].charAt(0) + (names[1] ? names[1].charAt(0) : ''); // Use an empty string if no second name

            let randomColor;
            do {
                randomColor = "#" + Math.floor(Math.random() * 16777215).toString(16);
            } while (randomColor === "#ffffff");

            const canvas = document.createElement("canvas");
            canvas.width = 100;
            canvas.height = 100;
            const context = canvas.getContext("2d");
            context.font = "50px Arial";
            context.textAlign = "center";

            context.fillStyle = randomColor;
            context.fillRect(0, 0, canvas.width, canvas.height);

            context.fillStyle = "#FFFFFF";
            context.fillText(firstLetter, canvas.width / 2, canvas.height / 2 + context.measureText(firstLetter).actualBoundingBoxAscent / 2);

            const dataURL = canvas.toDataURL();

            const img = document.createElement("img");
            this.avatar = dataURL;
        },
        timeSheetEndTimePickerOptions(start_time) {
            let end_time = '23:59:00';
            let obj = { selectableRange: `${moment(start_time).format('HH:mm:ss')} - ${end_time}`, format: 'HH:mm' };

            return obj;
        },
        getHoursToDisable(inHour) {
            // Disable hours before the selected In Time hour
            const hoursToDisable = [];
            for (let i = 0; i < inHour; i++) {
                hoursToDisable.push(i);
            }
            return hoursToDisable;
        },
        getMinutesToDisable(inMinute) {
            // Disable minutes before the selected In Time minute
            const minutesToDisable = [];
            for (let i = 0; i < inMinute; i++) {
                minutesToDisable.push(i);
            }
            return minutesToDisable;
        },
        handleClose() {
            this.$confirm('Are you sure you want to leave? All changes will be discarded/deleted.', 'Warning', {
                confirmButtonText: 'OK',
                cancelButtonText: 'Cancel',
                type: 'warning'
            }).then(() => {
                this.emp_shift_data = {};
                this.emp_shift_edit_dialog = false;
            }).catch(() => {

            });
        }
    },
}
</script>

<style lang="scss" scoped>
.ns-table-section {
    width: 100%;
    margin-top: 15px;
    height: 57vh;
    overflow-y: scroll;
}

.ns-sticky-header {
    position: sticky;
    top: 0;
    color: #707070;
    background-color: #f2f2f2 !important;
    z-index: 2;

    tr th {
        text-transform: uppercase !important;
        // text-align: center;
    }
}

.ns-time-sheet-tr {
    td {
        font-size: 13px !important;
    }
}

.title {
    font-weight: bold;
    font-size: 0.7rem;
}

.ellipsis {
    white-space: nowrap;
    // width: 180px;
    overflow: hidden;
    text-overflow: ellipsis;
}

.ns-sub-title {
    font-size: 10px;
    font-weight: 600;
}

.ns-gray {
    color: #707070;
}

.ns-img-avatar {
    border-radius: 99px;
    width: 50px;
}

.ns-avatar-sec {
    display: flex;
    align-items: center;
}

.ns-approve-btn {
    background: #41BE62;
    color: #fff;
    padding: 12px 35px;
    border-radius: 8px;
    font-weight: 600;
}

.mini-btn {
    padding: 9px 16px !important;
    border-radius: 4px !important;
}

.ns-approved-btn {
    background: #e72e2e;
    color: #fff;
    padding: 12px 35px;
    border-radius: 8px;
    font-weight: 600;
}

.ns-cancel-btn {
    border: none;
    padding: 12px 35px;
    border-radius: 8px;
    font-weight: 600;
}

.action-btn {
    background-color: #e29d5a;
    border-color: #e29d5a;
    color: #fff;
}

.ns-bottom-action-strip {
    bottom: -1px;
    width: 100%;
    z-index: 3;
    box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
    display: flex;
    align-items: center;
    height: 75px;
    justify-content: flex-end;
    padding: 0 15px;
}

.ns-table-popover {
    table {
        width: 100%;
    }

    .font-bold {
        font-weight: 600;
    }

    td {
        width: 120px;
        padding: 10px;
    }
}

.ns-today-time-sheet {
    margin: 0 2px;

    @media only screen and (min-width: 1540px) {
        margin: 0 60px;
    }
}

.ns-tito-cu-width {
    width: 410px;

    @media only screen and (min-width: 1540px) {
        width: 310px;
    }

    @media only screen and (max-width: 1308px) {
        width: 610px;
    }
}
</style> 

<style>
@media only screen and (max-width: 1308px) {
    .el-card__body{
        padding: 20px 5px !important;
    }
    .ns-ts-emp-col{
        width: 105px !important;
    }
}
</style>